import { MultichainActionType } from '@popup/multichain/actions/action-type.enum';
export const setHasFinishedSignup = (hasFinishedSignup) => {
    return {
        type: MultichainActionType.SET_HAS_FINISHED_SIGNUP,
        payload: hasFinishedSignup,
    };
};
